import React, { useState } from 'react';
import globalMaterialUITheme from '@alo/yoga-ui';
import WarmthGuideModel from './WarmthGuideModel';
import GuideBar from '../ProductBraGuide/GuideBar';
import { Grid, ThemeProvider, createMuiTheme, useMediaQuery } from '@material-ui/core';
import AloModal from 'src/scripts/templates/_shared/ui-components/YogaUI/alo-ui/AloModal';
import AloSidebar from 'src/scripts/templates/_shared/ui-components/YogaUI/alo-ui/AloSidebar';
import { MUI_MOBILE_BREAKPOINT } from 'src/scripts/utils/constants';
import styles from './styles.module.scss';

const WarmthGuide = ({ tags }: { tags: string[] }) => {
  const isMobile = useMediaQuery(MUI_MOBILE_BREAKPOINT, { noSsr: true });
  const [open, setOpen] = useState(false);

  const warmTags = tags.filter((tag) => tag.toLowerCase().startsWith('warmth:'));

  if (warmTags.length < 1) return null;

  const warmLevelTagArray = warmTags[0]?.split(':');
  const warmLevel = warmLevelTagArray ? warmLevelTagArray[warmLevelTagArray.length - 1]?.trim() : null;
  if (!warmLevel) return null;
  const imageAltText: Record<string, string> = {
    warm: 'Warm - Meter that shows jacket is on the lower end of the thermometer as warm',
    warmer: 'Warmer - Meter that shows jacket is the middle of the thermometer as warmer',
    warmest: 'Warmest - Meter that shows jacket is on the high end of the thermometer as warmest',
  };

  const WarmthGuideLevelArray: Record<string, number[]> = {
    warm: [1, 1, 0, 0, 0, 0],
    warmer: [0, 0, 1, 1, 0, 0],
    warmest: [0, 0, 0, 0, 1, 1],
  };

  const customMUITheme = createMuiTheme({
    ...globalMaterialUITheme,
  });

  return (
    <ThemeProvider theme={customMUITheme}>
      <Grid container direction="row" xs={!isMobile ? 12 : 'auto'} className={styles.warmthGuide}>
        <Grid xs={isMobile ? 12 : 'auto'}>
          <Grid item xs={!isMobile ? 12 : 'auto'}>
            <Grid container direction="row">
              <Grid item>
                <h2 className="warmth-guide-title">Warmth guide</h2>
              </Grid>
              <Grid item onClick={() => setOpen(true)}>
                <span className="alo-info-icon info-icon"></span>
              </Grid>
            </Grid>
          </Grid>
          <Grid item xs={!isMobile ? 12 : 'auto'}>
            <Grid container xs={12} direction="row" alignItems="flex-start" justify="space-between">
              <Grid item xs={4}>
                <span className="alo-single-heat-wave-icon single-heat-wave"></span>
              </Grid>
              <Grid item xs={4} className="display-center">
                <span className="alo-double-heat-wave-icon"></span>
              </Grid>
              <Grid item xs={4} className="display-right">
                <span className="alo-heat-wave-icon heat-wave"></span>
              </Grid>
            </Grid>
          </Grid>
          <Grid item xs={12}>
            <GuideBar
              guideMapping={WarmthGuideLevelArray[warmLevel?.toLowerCase()]}
              labels={['Warm', 'Warmer', 'Warmest']}
              ariaLabel={imageAltText[warmLevel?.toLowerCase()]}
            />
          </Grid>
        </Grid>
      </Grid>
      {isMobile ? (
        <AloSidebar headerBorder={false} visible={open} onClose={() => setOpen(false)} desktopWidth={730} title={''}>
          <WarmthGuideModel isMobile={true} />
        </AloSidebar>
      ) : (
        <AloModal
          wrapperClass={'warmth-guide-modal'}
          disableBackdropClick={false}
          open={open}
          showCloseButton={true}
          onClose={() => setOpen(false)}
        >
          <WarmthGuideModel />
        </AloModal>
      )}
    </ThemeProvider>
  );
};

export default WarmthGuide;
